import { css } from "styled-components";
import { alpha, color } from "./colorTools";
import { unit } from "./spaceTools";
import { altText, text } from "./textTools";
const variantColors = {
  default: undefined,
  secondary: color("neutral", 600),
  inverted: color.white,
  disabled: alpha("neutral", 24),
  alert: color("alert", 600),
  danger: color("danger", 500),
  interactive: color("accent", 600)
};
const variantStyles = _ref => {
  let {
    variant
  } = _ref;
  return variant === "interactive" ? css(["border-radius:", ";cursor:pointer;transition:0.1s ease-out;transition-property:box-shadow,color;&:hover{color:", ";}&:active{color:", ";}&:focus{box-shadow:0 0 0 ", " ", ";}"], unit(1), color("accent", 700), color("accent", 800), unit(4), color("accent", 200)) : {};
};
export const typography = {
  caption: css(["cursor:default;", " ", ""], _ref2 => {
    let {
      variant = "default",
      size
    } = _ref2;
    return text({
      color: variantColors[variant],
      fontSize: size === "s" ? 10 : 12
    });
  }, variantStyles),
  heading: css(["cursor:inherit;", " ", ""], _ref3 => {
    let {
      level,
      variant = "default"
    } = _ref3;
    return altText({
      color: variantColors[variant],
      fontSize: [40, 32, 24, 20, 16, 14][level - 1],
      fontWeight: 700
    });
  }, variantStyles),
  label: css(["cursor:default;", " ", ""], _ref4 => {
    let {
      variant = "default",
      size
    } = _ref4;
    return altText({
      color: variantColors[variant],
      fontSize: size === "s" ? 10 : 12,
      fontWeight: 700
    });
  }, variantStyles),
  text: css(["cursor:inherit;", " ", ""], _ref5 => {
    let {
      variant = "default",
      size
    } = _ref5;
    return text({
      color: variantColors[variant],
      fontSize: size === "s" ? 12 : undefined
    });
  }, variantStyles)
};
//# sourceMappingURL=typography.js.map